export default __webpack_public_path__ + "assets/img/image2.png";